import { Component, ViewContainerRef,OnInit,ElementRef,ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment'
import { Errors, UserService } from '../shared';

@Component({
  selector: 'auth-page',
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit {
  readPass = true;
  authType: String = '';
  title: String = '';
  errors: Errors = new Errors();
  isSubmitting = false;
  authForm: FormGroup;
  referenceId : string = '';
  getKey : string = '';
  ivKey: any

  @ViewChild('nameit') private elementRef: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef
  ) {
    // use FormBuilder to create a form group
    this.toastr.setRootViewContainerRef(vcr);
    this.authForm = this.fb.group({
      'email': ['', Validators.required],
      'password': ['', Validators.required]
    });
  }

 passFocus() {    
    this.readPass = false;
  }
  
  ngOnInit() {
   this.route.url.subscribe(data => {
      // Get the last piece of the URL (it's either 'login' or 'register')
      this.authType = data[data.length - 1].path;
      // Set a title for the page accordingly
      this.title = (this.authType === 'login') ? 'Sign in' : 'Sign up';
      // add form control for username if this is the register page
      if (this.authType === 'register') {
        this.authForm.addControl('username', new FormControl());
      }
    });

    this.userService.getKey().subscribe(data=>{
        this.referenceId = data.referenceId
        this.getKey = data.key
    })
  }

  submitForm() {
    // this.isSubmitting = true;
    // this.errors = new Errors();
    // const credentials = this.authForm.value;
    // this.userService
    // .attemptAuth(this.authType, credentials)
    // .subscribe(
    //   data => this.router.navigateByUrl('/'),
    //   err => {
    //     this.errors = err;
    //     this.isSubmitting = false;
    //     this.toastr.error("Invalid username/password");
    //   }
    // );
     this.isSubmitting = true;
      this.errors = new Errors();
      const credentials = this.authForm.value;
      credentials.userType='password'
      if(credentials.userType=='password'){
        credentials.userType=='password'
        var client_id = 'ENTigerClient'
      }else{
        var client_id = 'ENTigerLDAPClient'
      }
      this.ivKey = environment.iv_encryption_key
      let key = CryptoJS.enc.Utf8.parse(this.getKey);
      let iv  = CryptoJS.enc.Utf8.parse(this.ivKey);
      var encryptedpwd = CryptoJS.AES.encrypt(credentials.password, key, {iv: iv});
      var encryptedemail = CryptoJS.AES.encrypt(credentials.email, key, {iv: iv});
      var encryptedusertype = CryptoJS.AES.encrypt(credentials.userType, key, {iv: iv});
      var encryptedclient_id = CryptoJS.AES.encrypt(client_id, key, {iv: iv});
      var encryptedscope = CryptoJS.AES.encrypt('openid profile entigerapinew', key, {iv: iv});
      var encryptedsecret = CryptoJS.AES.encrypt('jgd123$', key, {iv: iv});
      let data = {
          grant_type: encryptedusertype.toString(),
          UserName: encryptedemail.toString(),
          Password: encryptedpwd.toString(),
          Client_id: encryptedclient_id.toString(),
          Scope: encryptedscope.toString(),
          Client_secret: encryptedsecret.toString(),
          referenceId: this.referenceId
      }
    // this.isSearching = true;
        this.userService
        .attemptAuth(this.authType, credentials, data)
        .subscribe(
          data => {
                let sessionInfo = {
                  LogInLongitude: 11,
                  LogInLatitude: 11,
                  SessionId: window.localStorage['jwtToken'],
                  LogInTime: new Date()
                }
                this.userService.loginSession(sessionInfo).subscribe((response: any) =>{
                        this.userService.fetchCurrentUserDetail().subscribe((response: any) =>{
                             this.router.navigateByUrl('/')
                        },
                        err=>{
                          this.toastr.error("Invalid Username");
                          this.isSubmitting = false;
                        })
              }, err => {
                  this.toastr.error("The user name or password is incorrect.");
                  this.isSubmitting = false;
              });
       },err => {
                  this.toastr.error("The user name or password is incorrect.");
                  this.isSubmitting = false;
       });   
  }

  checkAndSubmit(e) {
   if (e.keyCode == 13) {
     // this.submitForm()
   }
  }


}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts